const baseApiURL = 'http://www.vweb365.com/api/v1/'
const titleSite = '活动平台'
const baseHtmlURL = 'http://bm.sinacq.com/'

//判断是否是生产环境
var isPro = process.env.NODE_ENV === 'production' //process.env.NODE_ENV用于区分是生产环境还是开发环境
export default {
  baseApiURL,
  titleSite,
  baseHtmlURL,
  baseURL: isPro ? 'http://www.vweb365.com/api/v1' : '/api',
  imgHandle:function(url){
      if(url.indexOf("http")>=0){
        return url;
      }else{
        return this.baseHtmlURL+url;
      }
  },
  isPc:function(userInfo){
    let userAgentInfo =navigator.userAgent;
    let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
    let flag = true;
    for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    } 
    return flag;  
  },
  isWeiApp:function(){
       // return true;
        ////非生产环境不执行
        if(!isPro){
          return true;
        }
        let userAgentInfo = window.navigator.userAgent.toLowerCase();
        let flag = false;
        //let Agents = ["micromessenger", "weibo", "alibaba","QQ","qq"];
        let Agents = ["micromessenger", "weibo",];
        for (let v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                flag = true;
                break;
            }
        } 
        return flag; 
  },
  isIos:function(){
    let userAgentInfo =navigator.userAgent;
    let Agents = ["IOS", "iPhone", "Apple", "Mac"];
    let flag = false;
    for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = true;
            break;
        }
    } 
    return flag; 
  }
}


/*LoadModule negotiation_module modules/mod_negotiation.so
LoadModule proxy_module modules/mod_proxy.so
LoadModule proxy_http_module modules/mod_proxy_http.so
*/
/*
#反向代理
ProxyRequests Off
ProxyPass /api http://www.cqsinazp.com/api/v1/
ProxyPassReverse /api http://www.cqsinazp.com/api/v1/
 
#80为apache的监听端口
<proxy  http://localhost:80>
    AllowOverride None
    Order Deny,Allow
    Allow from all
</proxy>

*/


// WEBPACK FOOTER //
// ./src/api/global_variable.js